<div class="mt-2">
  <a [href]="termUrl" target="_blank">
    <i antIcon type="file-text" theme="outline"></i>&nbsp;<span appTranslate="terms"></span>
  </a>
</div>
